"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BitcoinInterfaceUtils = void 0;
const networks_1 = __importDefault(require("./utils/networks"));
const bitcoin_utils_1 = require("./bitcoin-utils");
class BitcoinInterfaceUtils {
    constructor(networkName) {
        this.testnet = networkName.includes("_testnet");
        this.network = networks_1.default[networkName];
    }
    convertHashToAddress(hashHex, addressType) {
        let addressObj = (0, bitcoin_utils_1.createAddressObjectByHash)({ addressType, hash: Buffer.from(hashHex, "hex") }, this.network);
        if (!addressObj.address)
            throw new Error("incorrect input");
        return addressObj.address;
    }
    convertScriptToAddress(scriptHex, addressType) {
        let addressObj = (0, bitcoin_utils_1.createAddressObjectByScript)({ addressType, script: Buffer.from(scriptHex, "hex") }, this.network);
        if (!addressObj.address)
            throw new Error("incorrect input");
        return addressObj.address;
    }
    convertAddressToScript(address) {
        let { addressObject, addressType } = (0, bitcoin_utils_1.createAddressObjectByAddress)(address, this.network);
        const hash = addressType === "p2tr" ? addressObject.pubkey : addressObject.hash;
        return {
            script: addressObject.output,
            hash,
            addressType,
        };
    }
    convertAddressToObject(address) {
        let addObj = (0, bitcoin_utils_1.createAddressObjectByAddress)(address, this.network);
        return addObj;
    }
    createAddressObjectByPublicKey(publicKey, addressType) {
        let addObj = (0, bitcoin_utils_1.createAddressObjectByPublicKey)({ publicKey: Buffer.from(publicKey, "hex"), addressType }, this.network);
        return addObj;
    }
}
exports.BitcoinInterfaceUtils = BitcoinInterfaceUtils;
exports.default = BitcoinInterfaceUtils;
//# sourceMappingURL=bitcoin-interface-utils.js.map